import type { PropsWithChildren } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { UserRole } from '../utils/auth';

export const Admin = ({ children }: PropsWithChildren) => {
  const { currentUserRole } = useAuthStore();

  return currentUserRole === UserRole.ADMIN ? children : null;
};
